.container {
  padding: 0.75rem 0.5rem;
  margin-bottom: 0.3rem;
  display: flex;
}

.info {
  background-color: var(--lightBlue);
  border: 1px solid var(--blue);
  border-left: 7px solid var(--blue);
  border-radius: 4px;
}

.error {
  border: 1px solid var(--red);
  border-left: 7px solid var(--red);
  border-radius: 4px;
}

.warning {
  background-color: var(--lightYellow);
  border: 1px solid var(--yellow);
  border-left: 7px solid var(--yellow);
  border-radius: 4px;
}

.container > p {
  margin-bottom: 0;
}

.container > span {
  margin-right: 0.5rem;
}

.warning > span {
  color: var(--yellow);
}

.info > span {
  color: var(--blue);
}

.error > span {
  color: var(--red);
}
